import { TileIds, TileRules } from '../../../util/tileEnums';

const deductibleProgressDescriptions = [
  {
    id: TileIds.DEDUCTIBLE_PROGRESS_IN_NETWORK_INDIVIDUAL_DEDUCTIBLE,
    subtext: 'individual deductible',
    isInNetwork: true,
    rules: [TileRules.HAS_INDIVIDUAL_DEDUCTIBLE_DATA],
  },
  {
    id: TileIds.DEDUCTIBLE_PROGRESS_IN_NETWORK_FAMILY_DEDUCTIBLE,
    subtext: 'family deductible',
    isInNetwork: true,
    rules: [TileRules.HAS_FAMILY_DEDUCTIBLE_DATA],
  },
  {
    id: TileIds.DEDUCTIBLE_PROGRESS_OUT_OF_NETWORK_INDIVIDUAL_DEDUCTIBLE,
    subtext: 'individual deductible',
    isInNetwork: false,
    rules: [TileRules.HAS_INDIVIDUAL_DEDUCTIBLE_DATA],
  },
  {
    id: TileIds.DEDUCTIBLE_PROGRESS_OUT_OF_NETWORK_FAMILY_DEDUCTIBLE,
    subtext: 'family deductible',
    isInNetwork: false,
    rules: [TileRules.HAS_FAMILY_DEDUCTIBLE_DATA],
  },
];
export { deductibleProgressDescriptions };
